import { AllEntityId } from '../config/allEntityId';
import { useReportEntityIds } from './useReportEntityIds';
import { useReportEntityType } from './useReportEntityType';

export const useSelectedEntityId = entityType => {
    const [selectedEntityIds] = useReportEntityIds();
    const [selectedEntityType] = useReportEntityType();

    return selectedEntityType === entityType ? selectedEntityIds : AllEntityId;
};
